import actions from '@ehi/global-marketing-interface/lib/actions';

/**
 * Sets the sms request consent (a.k.a. AutoComms || auto comms) flag
 *
 * @param      {boolean}    bool    The boolean flag true/false
 * @return     {Function}
 */
export const setAutoCommsConsent = (bool) => (dispatch) =>
  dispatch(actions.reservations.commitState.set('auto_comms_consent_opt_in', bool));
